module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/patientstatus/patientstatus.component.css
// module id = ./src/app/Pages/tasks/patientstatus/patientstatus.component.css
// module chunks = main